import { render } from "./carousel.vue?vue&type=template&id=3cd418fa&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=3cd418fa&lang=scss&scoped=true"
import "./carousel.vue?vue&type=style&index=1&id=3cd418fa&lang=scss"
script.render = render
script.__scopeId = "data-v-3cd418fa"

export default script